import React from 'react';
import NavigationTabs from 'pages/Dashboard/components/NavigationTabs';
import IconButton from 'core/components/IconButton';
import CloseIcon from '@mui/icons-material/Close';

type AdjustmentOption = {
  label: string;
  key: string;
  index: number;
};

const adjustmentOptions: AdjustmentOption[] = [
  { label: 'Move to Credit', key: 'moveToCredit', index: 0 },
  { label: 'Refund', key: 'refund', index: 1 },
];

type Props = {
  active: number;
  onChange: (index: number) => void;
  onClose: () => void;
  hideNavigation?: boolean;
  defaultTitle?: string;
};

export default function Title({
  active,
  onChange,
  onClose,
  hideNavigation,
  defaultTitle,
}: Props) {
  return (
    <div className="w-full flex justify-between items-start px-4 pt-4 min-h-[80px]">
      <div className="flex flex-1 flex-col gap-2">
        <h2 className="text-lg font-semibold">
          {defaultTitle ?? 'Adjust Patient Payments'}
        </h2>
        {!hideNavigation && (
          <NavigationTabs
            className="flex"
            tabs={adjustmentOptions}
            activeIndex={active}
            onClick={onChange}
          />
        )}
      </div>
      <IconButton
        tooltip="Close"
        onClick={onClose}
      >
        <CloseIcon className="!w-5 !h-5 !text-inherit" />
      </IconButton>
    </div>
  );
}
